export default __webpack_public_path__ + "static/blob-03-a8f4170501c8fe0575f4b6ec909c4522.svg";